"use client";

import { ArrowRight, Accessibility, Car, MapPin, TrainFront as Train } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Location() {
  const header = useRevealOnScroll<HTMLDivElement>();
  const mapWrap = useRevealOnScroll<HTMLDivElement>();
  const footer = useRevealOnScroll<HTMLDivElement>();
  const practical = [{
    icon: Car,
    label: "PARKING CERCANO"
  }, {
    icon: Accessibility,
    label: "ACCESO ADAPTADO"
  }, {
    icon: Train,
    label: "METRO IGLESIA · 3 MIN"
  }];
  return <section data-section-id="3142" id="ubicación-en-madrid" className="bg-background text-foreground py-24 md:py-32 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div ref={header.ref} className={`mb-12 md:mb-16 transition-all duration-700 ease-out ${header.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-8" style={{
            backgroundColor: "var(--primary)"
          }} />
            <span className="font-mono text-xs uppercase tracking-widest" style={{
            color: "var(--primary)"
          }}>
              Ubicación
            </span>
          </div>

          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
            <Link className="font-default font-semibold text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tighter uppercase md:mb-12 cursor-pointer" href="https://maps.app.goo.gl/RarxhtF49e5zQ1GdA" newTab><h2 className="font-default font-semibold text-5xl sm:text-6xl md:text-7xl lg:text-8xl leading-[0.92] tracking-tighter uppercase md:mb-12">Consulta<br /><span className="font-serif italic font-light normal-case" data-ast-id="f:/src/pages/Contact/sections/Location.tsx|sig:t0esim" data-ast-start="1756" data-ast-end="1863" contenteditable="false" style={{}}> en Madrid</span><span data-ast-id="f:/src/pages/Contact/sections/Location.tsx|sig:ig4i2a" data-ast-start="1878" data-ast-end="1954" style={{
                color: 'var(--primary)'
              }}>.</span></h2></Link>
            <Link className="font-serif italic text-lg md:text-xl text-muted-foreground max-w-sm leading-relaxed cursor-pointer" href="https://maps.app.goo.gl/RarxhtF49e5zQ1GdA" newTab><p className="font-serif italic text-lg md:text-xl text-muted-foreground max-w-sm leading-relaxed">Un espacio de psicoanálisis en el corazón de Chamberí.</p></Link>
          </div>
        </div>
      </div>

      <div ref={mapWrap.ref} className={`relative w-full py-6 md:py-8 transition-all duration-1000 ease-out ${mapWrap.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="relative w-full border border-border/40 shadow-lg rounded-lg overflow-hidden" style={{
          height: "600px"
        }}>
            <div className="absolute inset-0" style={{
            backgroundColor: "var(--background)",
            backgroundImage: "linear-gradient(var(--border) 1px, transparent 1px), linear-gradient(90deg, var(--border) 1px, transparent 1px)",
            backgroundSize: "80px 80px"
          }} />

            <svg className="absolute inset-0 w-full h-full" viewBox="0 0 1200 600" preserveAspectRatio="none" aria-hidden="true">
              <path d="M0,420 Q200,380 400,400 T800,360 T1200,300" stroke="var(--primary)" strokeWidth="1.5" fill="none" opacity="0.2" />
              <path d="M0,180 Q300,220 600,200 T1200,240" stroke="var(--primary)" strokeWidth="1" fill="none" opacity="0.15" />
              <path d="M300,0 Q340,150 380,300 T420,600" stroke="var(--primary)" strokeWidth="1" fill="none" opacity="0.1" />
              <path d="M900,0 Q880,200 860,400 T840,600" stroke="var(--primary)" strokeWidth="1" fill="none" opacity="0.1" />
              <path d="M0,520 Q300,480 550,420 T780,320" stroke="var(--primary)" strokeWidth="2" fill="none" strokeDasharray="4 6" opacity="0.4" />
            </svg>

            <div className="absolute" style={{
            left: "65%",
            top: "48%"
          }} aria-hidden="true">
              <Link className="absolute inline-flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 animate-ping opacity-40 underline cursor-pointer" to="https://maps.app.goo.gl/Gw4SJcmjr16atWY79" newTab>
                <span style={{
                backgroundColor: "var(--primary)",
                borderRadius: "var(--radius)"
              }} />
              </Link>
              <span className="absolute inline-flex h-10 w-10 -translate-x-1/2 -translate-y-1/2 animate-pulse opacity-60" style={{
              backgroundColor: "var(--primary)",
              borderRadius: "var(--radius)"
            }} />
              <Link className="relative flex items-center justify-center h-12 w-12 -translate-x-1/2 -translate-y-1/2 shadow-md underline cursor-pointer" href="https://maps.app.goo.gl/YCy23CVBxxff7xR58" newTab><div style={{
                backgroundColor: "var(--primary)",
                borderRadius: "var(--radius)"
              }}>
                <Link className="h-6 w-6 underline cursor-pointer" href="https://maps.app.goo.gl/YCy23CVBxxff7xR58" newTab><MapPin style={{
                    color: "var(--primary-foreground)"
                  }} strokeWidth={2.5} /></Link>
              </div></Link>
            </div>

            <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10 max-w-[420px] w-[calc(100%-3rem)] md:w-full backdrop-blur-sm border shadow-lg p-8 md:p-12 rounded-lg" style={{
            backgroundColor: "var(--card)",
            borderColor: "var(--border)"
          }}>
              <div className="flex items-center gap-3 mb-6">
                <span className="h-px w-6" style={{
                backgroundColor: "var(--primary)"
              }} />
                <span className="font-mono text-[10px] uppercase tracking-widest" style={{
                color: "var(--primary)"
              }}>
                  Ubicación
                </span>
              </div>

              <h3 className="font-default font-semibold text-2xl md:text-3xl leading-[1.1] tracking-tight uppercase mb-6">
                Antonio
                <br />
                Heredia
                <span style={{
                color: "var(--primary)"
              }}>.</span>
              </h3>

              <Link className="not-italic font-serif text-base md:text-lg leading-relaxed text-foreground/90 mb-6 underline cursor-pointer" href="https://maps.app.goo.gl/YCy23CVBxxff7xR58" newTab><address>
                Calle de Viriato, 57 - 28010 Madrid
              </address></Link>

              <Separator className="my-6" style={{
              backgroundColor: "var(--border)"
            }} />

              <div className="font-mono text-[11px] uppercase tracking-widest leading-relaxed text-muted-foreground mb-8">
                Atención presencial
                <br />
                Lunes–Viernes
                <br />
                Previa cita
              </div>

              <Button asChild size="lg" className="w-full justify-between font-mono text-xs uppercase tracking-widest h-12 px-6 shadow-md rounded-lg">
                <Link to="/contacto">
                  Solicitar Cita
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div ref={footer.ref} className={`mt-12 md:mt-16 transition-all duration-700 ease-out ${footer.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <div className="grid grid-cols-1 md:grid-cols-3 border-t border-b" style={{
          borderColor: "var(--border)"
        }}>
            {practical.map((item, i) => {
            const Icon = item.icon;
            return <div data-index={i} key={item.label} className={`flex items-center gap-4 py-8 md:py-10 px-2 md:px-6 shadow-sm rounded-lg ${i !== practical.length - 1 ? "md:border-r border-b md:border-b-0" : ""}`} style={{
              borderColor: "var(--border)"
            }}>
                  <div className="flex items-center justify-center h-10 w-10 shrink-0 border rounded-lg" style={{
                borderColor: "var(--border)",
                color: "var(--primary)"
              }}>
                    <Icon className="h-5 w-5" strokeWidth={1.5} />
                  </div>
                  <span className="font-mono text-xs uppercase tracking-widest text-foreground/90">
                    {item.label}
                  </span>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}